import React, { useRef, useState, useEffect } from 'react';
import rolling from '../../assets/icons/rolling.svg';
import { animated } from 'react-spring';
import AbsoluteContainer from '../containers/AbsoluteContainer';

function ImageLoader({ src, noIcon, style, invert, alt, gray, height, width }) {
    const [loaded, setLoaded] = useState(false);
    const imageRef = useRef();

    useEffect(() => {
        if (imageRef.current.complete) {
            setLoaded(true);
        } else {
            imageRef.current.onload = () => setLoaded(true);
        }
    }, []);

    return (
        <animated.div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                height,
                width,
            }}
        >
            <img
                ref={imageRef}
                draggable={false}
                style={{
                    opacity: loaded ? 1 : 0,
                    height: '100%',
                    objectFit: 'contain',
                    transition: 'opacity 250ms ease-out',
                }}
                src={src}
                alt={alt || ''}
            />
            <AbsoluteContainer
                style={{
                    opacity: loaded || noIcon ? 0 : 1,
                    top: 0,
                    left: 0,
                    background: invert
                        ? 'rgba(255,255,255,0.8)'
                        : gray
                        ? null
                        : 'rgba(255,255,255,0.9)',
                    transition: 'opacity 250ms ease-out',
                }}
            >
                <img
                    src={rolling}
                    draggable={false}
                    alt='loading'
                    style={{
                        height: '100px',
                        width: '100px',
                        maxHeight: '90%',
                        maxWidth: '90%',
                        objectFit: 'contain',
                        filter: invert
                            ? 'invert(100%)'
                            : gray
                            ? 'invert(50%)'
                            : null,
                    }}
                />
            </AbsoluteContainer>
        </animated.div>
    );
}

export default ImageLoader;
